var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "email-align-" + _vm.localMailAlign + " email" }, [
    !_vm.editingFieldLabel
      ? _c(
          "label",
          {
            staticClass: "field-label",
            attrs: { for: "email" },
            on: { click: _vm.focusFieldLabel },
          },
          [
            _vm._v("\n        " + _vm._s(_vm.displayFieldEmail) + "\n        "),
            _vm.isRequired
              ? _c("span", { staticClass: "required-indicator" }, [_vm._v("*")])
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.editingFieldLabel
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localFieldEmail,
              expression: "localFieldEmail",
            },
          ],
          ref: "fieldLabelInput",
          staticClass: "field-label-input",
          attrs: { type: "text", placeholder: "E-posta" },
          domProps: { value: _vm.localFieldEmail },
          on: {
            blur: _vm.stopEditingFieldLabel,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.stopEditingFieldLabel.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localFieldEmail = $event.target.value
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { class: ["input-wrapper", { filled: _vm.emailValue }] }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.emailValue,
            expression: "emailValue",
          },
        ],
        class: { "has-value": _vm.emailValue },
        attrs: { type: "email", id: "email", name: "email" },
        domProps: { value: _vm.emailValue },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.emailValue = $event.target.value
            },
            _vm.updateField,
          ],
          focus: _vm.onFocus,
          blur: _vm.onBlur,
        },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "floating-label", attrs: { for: "email" } }, [
        _vm._v(_vm._s(_vm.altLabel || "example@example.com")),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-border" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }